// Staging / feature gating helpers.
//
// The AI Chat page calls a separate backend (where-to-know-chat). It is exposed
// wherever a chat API base URL is configured via VUE_APP_CHAT_API — now set in
// both .env.development (staging) and .env.production (prod → chat.wheretoknow.com).

export function chatApiBase() {
  return (process.env.VUE_APP_CHAT_API || "").trim().replace(/\/$/, "");
}

// Libredesk 客服挂件。两个变量都配齐才启用；在某个环境留空即可在该环境关闭，
// 和上面 VUE_APP_CHAT_API 的做法一致。
export function libredeskBaseUrl() {
  return (process.env.VUE_APP_LIBREDESK_URL || "").trim().replace(/\/$/, "");
}

export function libredeskInboxId() {
  return (process.env.VUE_APP_LIBREDESK_INBOX_ID || "").trim();
}

export function isStaging() {
  const api = process.env.VUE_APP_BASE_API || "";
  const host = (typeof window !== "undefined" && window.location.hostname) || "";
  return (
    api.includes("staging") ||
    host.includes("staging") ||
    host === "localhost" ||
    host === "127.0.0.1"
  );
}

// Single source of truth for whether to expose the AI Chat page.
// Enabled wherever VUE_APP_CHAT_API is configured (staging AND prod); leave it
// empty in an env to hide the AI Chat page there.
export function isChatEnabled() {
  return !!chatApiBase();
}
